import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    paramKey: { type: String, default: "ordered_items" },
    handle: { type: String, default: ".sortable-handle" },
    draggable: { type: String, default: ".sortable-item" },
    animation: { type: Number, default: 150 },
    group: { type: String, default: "" },
    parentKey: { type: String, default: "" }
  }

  connect() {
    const groupConfig = this.groupValue
      ? { name: this.groupValue, pull: true, put: true }
      : { name: this.element.id, pull: false, put: false }

    this.sortable = new Sortable(this.element, {
      handle: this.handleValue,
      animation: this.animationValue,
      draggable: this.draggableValue,
      ghostClass: "sortable-ghost",
      dragoverBubble: true,
      group: groupConfig,
      onStart: this.onStart.bind(this),
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      if (Sortable.active) {
        this.sortable._onDrop = () => {}
      }
      this.sortable.destroy()
    }
    this.sortable = null
  }

  onStart() {
    this.element.classList.add("sorting-active")
  }

  onEnd(evt) {
    this.element.classList.remove("sorting-active")

    this.element.querySelectorAll(".sortable-ghost").forEach(el => {
      el.classList.remove("sortable-ghost")
    })

    if (this.groupValue && evt.from !== evt.to) {
      this.persistCrossContainerMove(evt)
    } else {
      this.persistOrder()
    }
  }

  persistOrder() {
    const items = this.element.querySelectorAll(`:scope > ${this.draggableValue}`)
    const ordered = Array.from(items).map((item, index) => ({
      id: parseInt(item.dataset.sortableId, 10),
      order: index
    }))
    this.sendPatch(ordered)
  }

  // Persistir orden en ambos containers (source y target) e incluir
  // parentKey para reasignar el padre del item movido.
  persistCrossContainerMove(evt) {
    const parentKey = this.parentKeyValue
    const draggable = this.draggableValue

    const collectItems = (container) => {
      const parentId = container.dataset.sortableParentId
      return Array.from(
        container.querySelectorAll(`:scope > ${draggable}`)
      ).map((item, index) => {
        const entry = {
          id: parseInt(item.dataset.sortableId, 10),
          order: index
        }
        if (parentKey && parentId) {
          entry[parentKey] = parseInt(parentId, 10)
        }
        return entry
      })
    }

    const ordered = [...collectItems(evt.to), ...collectItems(evt.from)]
    this.sendPatch(ordered)
  }

  sendPatch(ordered) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ [this.paramKeyValue]: ordered })
    })
      .then(resp => {
        if (!resp.ok) {
          console.error("[sortable] server error:", resp.status, resp.statusText)
          return
        }
        document.dispatchEvent(new CustomEvent("editor:record-saved", { bubbles: true }))
      })
      .catch(err => console.error("[sortable] network error:", err))
  }
}
